<template>
  <div>
    Speichern (
    <UKbd value="meta" />
    <span>+</span>
    <UKbd value="S" />)
  </div>
</template>
